// @core/api/endpoints/apikey/suspend_api_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyResponse,
  SuspendAPIKeyRequest,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Suspend API key
 * Temporarily suspends an API key, blocking access until reactivated. Optionally specify a suspension end time for automatic reactivation.
 */
export async function SuspendAPIKey(
  key_id: string,
  data: SuspendAPIKeyRequest,
  options?: RequestOptions
): Promise<APIKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id/suspend`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.post<APIKeyResponse>(requestPath, data, requestOptions);
}
